import axios from 'axios';

const Axios = axios.create();

// Read-only maintenance (config.underMaintenance): block mutating requests client-side so users get an
// instant, friendly stop instead of a round-trip that the backend gate would 503. Armed by
// MaintenanceTicker (which lives inside the toast provider) while it is mounted.
let readOnlyMode = false;
let onBlockedWrite = null;
const WRITE_METHODS = ['post', 'put', 'patch', 'delete'];

const setReadOnlyMode = (value) => {
  readOnlyMode = Boolean(value);
};

const setOnBlockedWrite = (handler) => {
  onBlockedWrite = handler;
};

Axios.interceptors.request.use((config) => {
  const method = (config.method || '').toLowerCase();
  if (readOnlyMode && WRITE_METHODS.includes(method)) {
    if (onBlockedWrite) onBlockedWrite();
    // Reject as an axios cancel so downstream error handlers (and Sentry) skip it -- it is a
    // deliberate block, not a failure.
    return Promise.reject(new axios.Cancel('under_maintenance'));
  }
  return config;
});

const responseHandler = (response) => {
  // this is default
  return response;
};

const setInterceptor = (errorHandler) => {
  Axios.interceptors.response.use(responseHandler, errorHandler);
};

export { Axios, setInterceptor, setReadOnlyMode, setOnBlockedWrite };
